import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
export const Title = styled.label `
  margin-right: 1rem;
`;
//# sourceMappingURL=items-per-page.styles.js.map